module.exports = __webpack_public_path__ + "img/welcome.b476e963.jpg";